import PageIntro from "@/components/site/PageIntro";
import CaseStudies from "@/components/site/CaseStudies";

export default function WorkPage() {
  return (
    <div data-testid="work-page">
      <PageIntro
        overline="Selected Work"
        title="Proof, not promises."
        subtitle="A snapshot of partnerships where technology quietly became a competitive edge. Open any project for the full story."
      />
      <CaseStudies />
    </div>
  );
}
